<template>
  <v-card
    :class="[
      'card py-12',
      {'align-start': settings['text-position-vertical'] === 'start'},
      {'align-center': settings['text-position-vertical'] === 'center'},
      {'align-end': settings['text-position-vertical'] === 'end'}
    ]"
    tile
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
    style="width: 100vw; position: relative;"
    elevation="0"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '408'"
    src
  >
    <div class="d-flex" style="width: 94%">
      <section 
        style="width: 100%" 
        :class="[
          'd-flex px-3',
          {'justify-end': settings['text-position'] === 'right'},
          {'justify-center': settings['text-position'] === 'center'},
          {'justify-start': settings['text-position'] === 'left'},        
        ]" 
      >
        <v-row 
          :style="`max-width: ${getMaxWidth}px;`" 
          no-gutters
        >
          <v-col v-if="$vuetify.breakpoint.mdAndUp && hasMedia && settings.media.alignment === 'left'" :class="['pr-5']">
            <AboutMedia :settings="settings"/>
          </v-col>

          <v-col 
            v-if="(!$vuetify.breakpoint.mdAndUp && hasMedia && settings.media.alignment !== 'center')" 
            cols="12" 
            class="text-center pb-5"
          >
            <AboutMedia :settings="settings"/>
          </v-col>          

          <v-col>
            <div 
              :class="[
                {'text-start': settings.title.alignment === 'left'}, 
                {'text-center': settings.title.alignment === 'center'}, 
                {'text-end': settings.title.alignment === 'right'}              
              ]"
            >
              <h1
                class="mb-5"
                :style="
                  `
                  font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
                  font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                  color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
                  font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
                  font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
                  text-align: ${settings.text['text-align']}
                  `
                "
              >
                {{ settings.title.content }}
              </h1>
            </div>

            <div 
              :class="[
                {'text-start': settings.text.alignment === 'left'}, 
                {'text-center': settings.text.alignment === 'center'}, 
                {'text-end': settings.text.alignment === 'right'}              
              ]"              
            >
              <span v-html="formatedText"></span>
            </div>

            <div 
              v-if="haveButtons" 
              style="gap: 16px"
              :class="[
                'align-item',
                {'justify-start': settings['button-alignment'] === 'left'}, 
                {'justify-center': settings['button-alignment'] === 'center'}, 
                {'justify-end': settings['button-alignment'] === 'right'}              
              ]"              
            >
              <span v-for="(item, index) in settings.buttons" :key="index">
                <v-btn
                  v-if="item.caption && item.action"
                  class="mt-5"
                  elevation="0"
                  height="44px"
                  :style="
                    `
                    background-color: ${MIXIN_getStyle(settings, 'button', 'background-color', index)} !important;
                    border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius', index)} !important
                    `
                  "
                  :disabled="oneCheckoutOpen"
                  @click="actionButton(index)"
                  >
                  <b
                    :style="
                      `
                      color: ${MIXIN_getStyle(settings, 'button', 'color', index)} !important;
                      `
                    "
                  >
                    {{ item.caption }}
                  </b>
                </v-btn>
              </span>
            </div>
          </v-col>

          <v-col v-if="$vuetify.breakpoint.mdAndUp && hasMedia && settings.media.alignment === 'right'" :class="['pl-5']">
            <AboutMedia :settings="settings"/>
          </v-col>

          <v-col 
            v-if="
              (!$vuetify.breakpoint.mdAndUp && hasMedia && settings.media.alignment === 'center') || 
              ($vuetify.breakpoint.mdAndUp && hasMedia && settings.media.alignment === 'center')
            "
            cols="12" 
            class="text-center mt-5 pb-5"
          >
            <AboutMedia :settings="settings"/>
          </v-col>
        </v-row>
      </section>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"
import AboutMedia from './AboutMedia.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  components: {AboutMedia},
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      alignCenter: true,
      height: "650px",
      hover: false,
    };
  },
 
  computed: {
    ...mapGetters(["infos", "oneCheckoutOpen"]),
    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<p style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: 1.5rem !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          // .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    },

    hasMedia () {
      return (this.settings.media && this.settings.media.type === 'image' && this.settings.media.content) ||
        (this.settings.media && this.settings.media.type === 'youtube' && this.settings.media.videoid)
    },

    getMaxWidth () {
      let width = 800
      const hasMidia = this.settings.media.content && this.settings.media.type === 'image' || 
        this.settings.media.videoid && this.settings.media.type === 'youtube'

      if (this.$vuetify.breakpoint.xlOnly) width += 200
      if (hasMidia) {
        if (this.$vuetify.breakpoint.xlOnly) width += 500
        else if (this.$vuetify.breakpoint.mdAndUp) width += 450
      }
      return width
    },

    haveButtons () {
      const checkButtons = this.settings.buttons.some(btn => btn.caption && btn.action)
      return checkButtons
    }    
  },

  methods: {
    formatYoutube(code) {
      return `https://www.youtube.com/embed/${code}`;
    },

    actionButton(index) {
      if (
        this.settings.buttons[index].action &&
        this.settings.buttons[index].action.charAt(0) === "#"
      )
        this.$vuetify.goTo(this.settings.buttons[index].action);
      else if (this.settings.buttons[index].action === "Abrir Checkout") {
        this.openCheckout()
      }
      else if (this.settings.buttons[index].action.includes('page-')) {
        const page = this.infos.pages.find(page => page.id === this.settings.buttons[index].action)
        if (page) {
          this.$router.push({name: 'CustomBodyPage', params: {page: page.route.split('/')[1]}})
          this.$store.dispatch('setSelectedPage', this.settings.buttons[index].action)
        }
      } else {
        let url = this.settings.buttons[index].action
        if (!url.includes('http://') || !url.includes('https://')) url = `https://${url}`
        window.open(url, '_blank')
      } 
    },
    
    openCheckout() {
      this.$store.dispatch("setOneCheckoutOpen", true);
    },
  },
};
</script>

<style scoped>
.card {
  display: flex;
  justify-content: center;
  align-items: center;
}

h1 {
  font-size: 37px;
  font-style: normal;
  font-weight: 700;
  line-height: 45px;
  letter-spacing: 0px;
}

span {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
}

.align-item {
  display: flex;
  flex-wrap: wrap;
  width: 100% !important;
}
</style>
